import React from 'react'

import Amount from '../currency/amount'

type Props = {
  value: number
  mode: 'amount' | 'count'
  currencySymbol?: string
  className?: string
  countLabel?: (count: number) => React.ReactNode
}

const AnimatedSummaryValue: React.FC<Props> = ({
  value,
  mode,
  currencySymbol,
  className,
  countLabel,
}) => {
  if (mode === 'count') {
    const rounded = Math.round(value)
    if (rounded <= 0) return null
    return (
      <span className={className}>
        {countLabel ? countLabel(rounded) : `${rounded} ${rounded === 1 ? 'invoice' : 'invoices'}`}
      </span>
    )
  }

  return (
    <span className={className}>
      <Amount value={value} currencySymbol={currencySymbol} />
    </span>
  )
}

export default AnimatedSummaryValue
